import { render, staticRenderFns } from "./ButtonSelect.vue?vue&type=template&id=6a901d9a&"
import script from "./ButtonSelect.vue?vue&type=script&lang=ts&"
export * from "./ButtonSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports